import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyService } from '@cp/shared/data-access/company/company.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor(private _companyService: CompanyService) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const company = this._companyService.company;
    const headers: { [p: string]: string | Array<string> } = {};

    if (company) {
      headers['x-company'] = company;
    } else {
      console.error('Company not set for request');
      return next.handle(request);
    }

    const requestWithHeaders = request.clone({
      setHeaders: headers,
    });

    return next.handle(requestWithHeaders);
  }
}
